import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  appBar: {
    height: '3rem',
    zIndex: 10,
    borderRadius: '0 0 30px 30px',
    [theme.breakpoints.only('lg')]: {
      height: '4.3rem'
    },
    [theme.breakpoints.only('xl')]: {
      height: '4.5rem'
    },
    [theme.breakpoints.up('xxl')]: {
      height: '5rem'
    }
  },
  toolBar: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    userSelect: 'none',
    alignItems: 'center',
    borderRadius: '0 0 30px 30px',
    [theme.breakpoints.up('md')]: {
      padding: '0 48px'
    }
  },
  logo: {
    width: '4rem',
    [theme.breakpoints.only('xl')]: {
      width: '5rem'
    }
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px'
  },
  linkText: {
    '&:hover': {
      textShadow: '0.045em 0px currentColor'
    }
  },
  boxOptionsLanguage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '6px'
  },
  option: {
    color: theme.palette.grey['300'],
    cursor: 'pointer'
  },
  activeOption: {
    color: theme.palette.primary.contrastText,
    fontWeight: 600
  },
  divider: {
    backgroundColor: theme.palette.grey[300],
    padding: '0 1px'
  }
}))
